<template>
  <div>
    <div class="mb-3 d-flex justify-content-end" :class="{invisible: objectList.length === 0}">
      <v-button
        text="phrase.register_research"
        icon="plus"
        :route-to="{name: 'organisation-register-research-start'}"
      />
    </div>
    <div class="row">
      <div class="col-md-4 mb-3">
        <div class="card card-body bg-light">
          <form method="post" @submit.prevent="getObjects()">
            <div class="mb-2">
              <v-text-input
                size="lg"
                placeholder="word.search"
                v-model="searchQuery"
              />
            </div>

            <hr />

            <v-check-box
              :label="$tc('word.brand_research', 2)"
              :translate-text="false"
              v-model="filters.brandResearches"
            />

            <v-check-box
              :label="$tc('word.tv_commercial', 2)"
              :translate-text="false"
              v-model="filters.tvCommercials"
            />

            <v-check-box
              :label="$tc('word.radio_commercial', 2)"
              :translate-text="false"
              v-model="filters.radioCommercials"
            />

            <v-check-box
              :label="$tc('word.ooh_commercial', 2)"
              :translate-text="false"
              v-model="filters.oohCommercials"
            />
            <hr />

            <v-button
              size="sm"
              text="word.reset"
              @click="reset"
              :block="true"
              style-type="link"
              type="button"
            />

            <v-button
              size="sm"
              text="word.filter"
              :block="true"
              style-type="secondary"
              type="submit"
            />
          </form>
        </div>
      </div>
      <div class="col-lg-8" v-if="objectList.length > 0">
        <div class="row">
          <div
            class="col-lg-6"
            v-for="research in objectList"
            :key="research.uuid"
          >
            <v-organisation-research-card
              :uuid="research.uuid"
              :title="research.title"
              :description="research.description"
              :start-date="research.start_date ? new Date(research.start_date) : null"
              :end-date="research.start_date ? new Date(research.end_date) : null"
              :group-size="research.group_size"
              :sessions-count="research.sessions_count"
              :status="research.status"
              :commercial="research.commercial"
              @click="goToResearch"
            />
          </div>
        </div>
        <div v-if="loading" class="d-flex justify-content-center">
          <v-loader />
        </div>

        <div class="p-3 d-flex justify-content-center" v-else-if="nextPageUrl">
          <v-button
            text="phrase.load_more"
            @click="getObjects(nextPageUrl, true)"
          />
        </div>
      </div>
      <div class="col-md-8" v-else>
        <div
          class="d-flex flex-column justify-content-center align-items-center text-muted"
        >
          <i class="fa fa-folder-open icon-large mb-2"></i>
          <div class="mb-2">
            {{ $t('sentence.no_researches') }}
          </div>
          <v-button
            text="phrase.register_research"
            icon="plus"
            :route-to="{name: 'organisation-request-research'}"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import { setBreadcrumbs } from '@/common/utils/breadcrumbs';
import { GenericListMixin } from '@/common/utils/mixins';
import OrganisationResearchCard from '@/organisation/components/OrganisationResearchCard.vue';
import Loader from '@/common/components/Loader.vue';
import Button from '@/common/components/Button.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import CheckBox from '@/common/components/inputs/CheckBox.vue';

export default {
  name: 'ResearchListView',
  components: {
    'v-button': Button,
    'v-check-box': CheckBox,
    'v-loader': Loader,
    'v-organisation-research-card': OrganisationResearchCard,
    'v-text-input': TextInput,
  },
  data() {
    return {
      apiPath: 'org/researches/',
      filters: {
        tvCommercials: false,
        radioCommercials: false,
        oohCommercials: false,
        brandResearches: false,
      },
    };
  },
  methods: {
    getParams() {
      let types = '';
      if (this.filters.tvCommercials) {
        types += 'tv,';
      }
      if (this.filters.radioCommercials) {
        types += 'radio,';
      }
      if (this.filters.oohCommercials) {
        types += 'ooh,';
      }
      if (this.filters.brandResearches) {
        types += 'research,';
      }

      return {
        types,
        organisation_slug: this.org.slug,
      };
    },
    goToResearch(uuid, status) {
      if (status === 'draft') {
        this.$router.push({ name: 'organisation-research-edit', params: { uuid } });
        return;
      }
      this.$router.push({ name: 'organisation-research-dashboard', params: { uuid } });
    },
    reset() {
      this.filters.tvCommercials = false;
      this.filters.radioCommercials = false;
      this.filters.oohCommercials = false;
      this.filters.brandResearches = false;
      this.searchQuery = '';
      this.getObjects();
    },
  },
  mixins: [
    GenericListMixin,
  ],
  computed: {
    ...mapGetters(['org']),
  },
  created() {
    setBreadcrumbs('organisation.researchList');
  },
};
</script>
